import { array, isFunction, isValid } from "@visactor/vutils";

import { BaseTooltipHelper } from "../../model/tooltip-helper";

import { getTooltipActualActiveType } from "../../component/tooltip/utils/common";

export class BaseSeriesTooltipHelper extends BaseTooltipHelper {
    constructor(series) {
        super(), this._getSeriesCacheInfo = () => {
            var _a, _b, _c;
            const {series: series} = this, _seriesField = series.getSeriesField();
            return {
                seriesFields: isValid(_seriesField) ? array(_seriesField) : null !== (_a = series.getSeriesKeys()) && void 0 !== _a ? _a : [],
                dimensionFields: null !== (_b = series.getDimensionField()) && void 0 !== _b ? _b : [],
                measureFields: null !== (_c = series.getMeasureField()) && void 0 !== _c ? _c : [],
                type: series.type
            };
        }, this._getDimensionData = datum => {
            const {dimensionFields: dimensionFields} = this._seriesCacheInfo;
            return dimensionFields[0] && (null == datum ? void 0 : datum[dimensionFields[0]]);
        }, this._getMeasureData = datum => {
            const {measureFields: measureFields} = this._seriesCacheInfo;
            return measureFields[0] && (null == datum ? void 0 : datum[measureFields[0]]);
        }, this._getSeriesFieldData = datum => {
            const {dimensionFields: dimensionFields, seriesFields: seriesFields} = this._seriesCacheInfo;
            if (isValid(seriesFields[0]) && (null == datum ? void 0 : datum[seriesFields[0]])) return null == datum ? void 0 : datum[seriesFields[0]];
            const subDimensionField = dimensionFields[dimensionFields.length - 1];
            return dimensionFields.length > 1 && (0 === seriesFields.length || this.series.getSeriesKeys().length), 
            null == datum ? void 0 : datum[subDimensionField];
        }, this._getSeriesStyle = (datum, styleKey, defaultValue) => {
            var _a;
            for (const key of array(styleKey)) {
                const value = null === (_a = this.series.getSeriesStyle(datum)) || void 0 === _a ? void 0 : _a(key);
                if (isValid(value)) return value;
            }
            return defaultValue;
        }, this.markTooltipKeyCallback = (datum, params) => this._getSeriesFieldData(datum), 
        this.markTooltipValueCallback = (datum, params) => this._getMeasureData(datum), 
        this.shapeTypeCallback = (datum, params) => {
            var _a;
            return null !== (_a = this._getSeriesStyle(datum, "shape", null)) && void 0 !== _a ? _a : this._getSeriesStyle(datum, "symbolType", this.series.getDefaultShapeType());
        }, this.shapeColorCallback = (datum, params) => this._getSeriesStyle(datum, [ "fill", "stroke" ]), 
        this.shapeStrokeCallback = (datum, params) => this._getSeriesStyle(datum, [ "stroke", "fill" ]), 
        this.dimensionTooltipTitleCallback = (datum, params) => this._getDimensionData(datum), 
        this.groupTooltipTitleCallback = (datum, params) => this._getSeriesFieldData(datum), 
        this.groupTooltipKeyCallback = (datum, params) => {
            const {seriesFields: seriesFields} = this._seriesCacheInfo;
            let dimensionFields = this._seriesCacheInfo.dimensionFields;
            return seriesFields[0] && (dimensionFields = dimensionFields.filter((field => field !== seriesFields[0]))), 
            dimensionFields.map((field => null == datum ? void 0 : datum[field])).join("-");
        }, this.series = series, this.updateTooltipSpec();
    }
    updateTooltipSpec() {
        var _a, _b, _c, _d;
        const seriesTooltipSpec = null !== (_b = null === (_a = this.series.getSpec()) || void 0 === _a ? void 0 : _a.tooltip) && void 0 !== _b ? _b : {}, chartTooltipSpec = null !== (_d = null === (_c = this.series.getChart().getSpec()) || void 0 === _c ? void 0 : _c.tooltip) && void 0 !== _d ? _d : {}, spec = Object.assign(Object.assign({}, chartTooltipSpec), seriesTooltipSpec);
        [ "mark", "dimension", "group" ].forEach((activeType => {
            const pattern = spec[activeType];
            isValid(pattern) && (spec[activeType] = Object.assign(Object.assign({}, pattern), {
                title: addExtraInfoToTooltipTitlePattern(pattern.title, {
                    seriesId: this.series.id
                }, !0),
                content: addExtraInfoToTooltipContentPattern(pattern.content, {
                    seriesId: this.series.id
                }, !0)
            }));
        })), this.spec = spec, this.activeType = getTooltipActualActiveType(spec), this._seriesCacheInfo = this._getSeriesCacheInfo();
    }
    getDefaultTooltipPattern(activeType, dimensionInfo) {
        switch (activeType) {
          case "mark":
            return {
                visible: !0,
                activeType: activeType,
                title: {
                    key: void 0,
                    value: this.dimensionTooltipTitleCallback,
                    hasShape: !1
                },
                content: [ {
                    seriesId: this.series.id,
                    key: this.markTooltipKeyCallback,
                    value: this.markTooltipValueCallback,
                    hasShape: !0,
                    shapeType: this.shapeTypeCallback,
                    shapeColor: this.shapeColorCallback,
                    shapeStroke: this.shapeStrokeCallback,
                    shapeHollow: !1
                } ]
            };

          case "group":
            return {
                visible: !0,
                activeType: activeType,
                title: {
                    key: void 0,
                    value: this.groupTooltipTitleCallback,
                    hasShape: !1
                },
                content: [ {
                    seriesId: this.series.id,
                    key: this.groupTooltipKeyCallback,
                    value: this.markTooltipValueCallback,
                    hasShape: !0,
                    shapeType: this.shapeTypeCallback,
                    shapeColor: this.shapeColorCallback,
                    shapeStroke: this.shapeStrokeCallback,
                    shapeHollow: !1
                } ]
            };

          case "dimension":
            if (dimensionInfo) {
                const title = {
                    key: void 0,
                    value: this.dimensionTooltipTitleCallback,
                    hasShape: !1
                }, content = [];
                return dimensionInfo.forEach((({data: data}) => data.forEach((({series: series}) => {
                    content.push({
                        seriesId: series.id,
                        key: this.markTooltipKeyCallback,
                        value: this.markTooltipValueCallback,
                        hasShape: !0,
                        shapeType: this.shapeTypeCallback,
                        shapeColor: this.shapeColorCallback,
                        shapeStroke: this.shapeStrokeCallback,
                        shapeHollow: !1
                    });
                })))), {
                    visible: !0,
                    activeType: activeType,
                    title: title,
                    content: content
                };
            }
        }
        return null;
    }
}

const merge = (source, extraInfo, overwrite) => {
    const info = isFunction(extraInfo) ? extraInfo(source) : extraInfo;
    return overwrite ? Object.assign(Object.assign({}, source), info) : Object.assign(Object.assign({}, info), source);
};

export const addExtraInfoToTooltipTitlePattern = (pattern, extraInfo, overwrite) => isValid(pattern) ? isFunction(pattern) ? (...args) => merge(pattern(...args), extraInfo, overwrite) : merge(pattern, extraInfo, overwrite) : void 0;

export const addExtraInfoToTooltipContentPattern = (pattern, extraInfo, overwrite) => isValid(pattern) ? array(pattern).map((patternItem => isFunction(patternItem) ? (...args) => array(patternItem(...args)).map((line => merge(line, extraInfo, overwrite))) : merge(patternItem, extraInfo, overwrite))) : void 0;
//# sourceMappingURL=tooltip-helper.js.map
